const STATUS_INDISPONIVEL = [404, 502, 503, 504];

export function csProdIndisponivel(erro) {
  return (
    !erro?.response ||
    erro?.code === "ECONNABORTED" ||
    STATUS_INDISPONIVEL.includes(erro?.response?.status)
  );
}

export function mensagemErroCsProd(erro, fallback) {
  if (csProdIndisponivel(erro)) {
    return "CSAPI de produção indisponível — tente novamente mais tarde";
  }
  return (
    erro?.response?.data?.message ||
    erro?.response?.data?.error ||
    erro?.message ||
    fallback
  );
}
